import { render } from "./Ingredients.vue?vue&type=template&id=187db46c&scoped=true"
import script from "./Ingredients.vue?vue&type=script&lang=ts"
export * from "./Ingredients.vue?vue&type=script&lang=ts"

import "./Ingredients.vue?vue&type=style&index=0&id=187db46c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-187db46c"

export default script